import {useMemo, useState} from 'react';
import {DropdownItemData} from '@priority-software/priority-style-react/dist/components/DropdownV2/ChooseDropdown/ChooseDropdown';
import {useEventCallback} from 'usehooks-ts';
import {$getSelection, $isRangeSelection} from 'lexical';
import {$patchStyleText} from '@lexical/selection';
import {IUseFontDropdown} from './types';
import {addPx} from '../ToolbarPlugin/utils';
import {FONT_SIZE, LINE_HEIGHT} from '../../constants';
import {isRTL} from '../../../../../../Localization';

export const useFontDropdown = ({mode, value, editor}: IUseFontDropdown) => {
    const [selected, setSelected] = useState<DropdownItemData>(value);

    const handleChange = useEventCallback(
        (option: DropdownItemData, isSelected: boolean, name?: string) => {
            if (isSelected) {
                setSelected(isSelected ? option : null);
                handleEditor(option.value as string);
            }
        }
    );

    const handleEditor = (option: string) => {
        const style =
            mode === FONT_SIZE
                ? {
                      [mode]: addPx(option),
                      [LINE_HEIGHT]: addPx(`${parseInt(option, 10) * 1.2}`)
                  }
                : {[mode]: option};

        editor?.update(() => {
            const selection = $getSelection();
            if ($isRangeSelection(selection)) {
                $patchStyleText(selection, style);
            }
        });
    };

    const isFontSize = useMemo(() => mode === FONT_SIZE, [mode]);

    return {
        handleChange,
        isFontSize,
        selected,
        isRTL: isRTL()
    } as const;
};
